var path = 'views/error/error.html';
var html = "<div> <h1 translate>error.errorHeader</h1> <p translate>error.errorDescription</p> </div> ";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;